import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import { skillNameSelector } from "../../../recoil/TargetSkillScore/selector";
import { useSetRecoilState } from "recoil";
import useStyles from "./styles";
import { size, slice } from "lodash";
import { useMainTheme } from "../../../hooks/useMainTheme";
import { checkArrayLength } from "src/utils";

const SkillScoreChart = ({
  totalRaters,
  skillsCount = 0,
  skills = [],
  nodataSkill = [],
  selectedSkillName,
  setSelectedSkillName,
  fromDashboard = false,
}) => {
  const styleProps = useMainTheme();
  const classes = useStyles(styleProps);
  const { t } = useTranslation();
  const _setSkillName = useSetRecoilState(skillNameSelector);
  const [skillsToDisplay, setSkillsToDisplay] = useState([]);
  const [selectedPageIndex, setSelectedPageIndex] = useState(0);
  const skillsPerPage = 5;
  const skillPagesCount =
    (skillsCount + nodataSkill.length) / skillsPerPage < 1
      ? 1
      : Math.ceil((skillsCount + nodataSkill.length) / skillsPerPage);

  let skillPages = [...Array(skillPagesCount).keys()];
  // if (skillPages.length === 0) skillPages = [1];

  useEffect(() => {
    let takeSkillsToDisplay = [];
    if (selectedPageIndex) {
      takeSkillsToDisplay = slice(
        skills,
        selectedPageIndex * skillsPerPage,
        skillsPerPage * (selectedPageIndex + 1)
      );
    } else {
      takeSkillsToDisplay = slice(skills, selectedPageIndex, skillsPerPage);
    }
    setSkillsToDisplay(takeSkillsToDisplay);
  }, [selectedPageIndex, skills]);
  const mappedSelectedSkill = skills?.find(
    (res) => res.skill === selectedSkillName
  );
  return (
    <div>
      <Box display="flex" justifyContent="center">
        <Box className={classes.taggedSkills}>
          <div className={`${classes.semiCircle2} semi-circle`}>
            {fromDashboard ? (
              <span className={`${classes.semiCircleTitle2} semi-circle-title`}>
                {t("Skills tagged")} <b>{size(skills)}</b>
              </span>
            ) : (
              <span className={`${classes.semiCircleTitle2} semi-circle-title`}>
                {t("Rated")} <b>{mappedSelectedSkill?.ratedByCount || 0}</b>
                {t("times")}
              </span>
            )}

            <ul className={`${classes.skillList} skill-list`}>
              {skillsToDisplay.map((res, index) => {
                return (
                  <li
                    key={index}
                    className={
                      selectedSkillName === res.skill ? "selected-skill" : ""
                    }
                    data-testid="skillName"
                    onClick={() => {
                      setSelectedSkillName(res.skill);
                      _setSkillName(res.skill);
                    }}
                  >
                    <span className={classes.animateCss}>
                      <span className={classes.skillNameList}>
                        {res.skill}
                        {/* {res.score && "(" + res.score + ")"} */}
                      </span>
                      {fromDashboard ? (
                        res.count ? (
                          <span className={`${classes.count} count`}>
                            {`${res.count}%`}
                          </span>
                        ) : (
                          ""
                        )
                      ) : (
                        <span className={`${classes.count} count`}>
                          {Number.isInteger(res?.count)
                            ? `${res.count}%`
                            : "NR"}
                        </span>
                      )}
                    </span>
                  </li>
                );
              })}
              {skillsToDisplay.length < skillsPerPage
                ? nodataSkill.map((res, key) => {
                    return (
                      <li key={key} className={classes.noSkill}>
                        {t("text.noData")}{" "}
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </Box>
      </Box>
      <Box className={classes.dotsWrapper} mt={5}>
        {skillPages.length > 1 &&
          skillPages.map((skill, i) => {
            return (
              <span
                key={i}
                data-testid={"skillPage"}
                onClick={() => setSelectedPageIndex(i)}
                className={`${classes.dot} ${
                  i === selectedPageIndex && classes.filledBackground
                }`}
              ></span>
            );
          })}
      </Box>
      {/* <Typography variant="subtitle2" className={classes.skillName}>
        {selectedSkillName}
      </Typography> */}

      {totalRaters ? (
        <Box textAlign="right">
          <Typography className="font-12 f-light-gray">
            {`Skills tagged: ${checkArrayLength(skills)} `}
            <span className="mr5 ml5">|</span> Raters:{" "}
            {mappedSelectedSkill?.ratedByCount} of {totalRaters}
          </Typography>
        </Box>
      ) : null}
    </div>
  );
};

export default SkillScoreChart;
